<template>
  <div class="outer-wrapper">
    <div v-if="this.step === 'one'">
      <slot name="stepOneHeadline"></slot>
      <div class="content">
        <div class="inner">
          <div class="bubble">
            <slot name="stepOneContent"></slot>
            <div class="button-box">
              <div class="btn-left">
                <button :aria-label="ariaLabelLeftStep1" @click="next()"><slot name="stepOneButtonLeft"></slot></button>
              </div>
              <div class="btn-right">
                <slot name="stepOneButtonRight"></slot>
              </div>
            </div>
          </div>
          <slot name="stepOneImage"></slot>
        </div>
      </div>
      <slot name="StepOne2"></slot>
    </div>
    <div v-if="this.step === 'two'">
      <slot name="stepTwoHeadline"></slot>
      <div class="content">
        <div class="inner">
          <div class="bubble" >
            <slot name="stepTwoContent"></slot>
            <div class="button-box">
              <div class="btn-left">
                <button :aria-label="ariaLabelLeftStep2" @click="back()"><slot name="stepTwoButtonLeft"></slot></button>
              </div>
              <div class="btn-right">
                <slot name="stepTwoButtonRight"></slot>
              </div>
            </div>
          </div>
          <slot name="stepTwoImage"></slot>
        </div>
      </div>
      <slot name="StepOne2"></slot>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PreActivationSteps',
  mounted () {
    this.triggerTrackingInfo()
  },
  data () {
    return {
      step: 'one'
    }
  },
  methods: {
    next () {
      this.step = 'two'
      document.getElementById('headlineStep1').focus()
      this.triggerTrackingInfo()
    },
    back () {
      this.step = 'one'
      document.getElementById('headlineStep2').focus()
      this.triggerTrackingInfo()
    },
    triggerTrackingInfo () {
      const data = {
        page_levels: [
          'mobility',
          'sim activation',
          'retail check',
          this.step === 'one' ? 'question' : 'not purchased from retail'
        ],
        login_status: 'not logged in', // check/set in tracking
        page_type: 'content',
        platform_type: 'browser view'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', data)
      }
    }
  },
  computed: {
    ariaLabelLeftStep1 () {
      return this.getSlotText('stepOneButtonLeftAriaLabel')
    },
    ariaLabelLeftStep2 () {
      return this.getSlotText('stepTwoButtonLeftAriaLabel')
    }
  }
}
</script>
